import VideoCard from "@/components/base/VideoCard";
import { featuredVideos } from "@/mocks/videos";

export default function FeaturedVideos() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100" aria-label="推荐视频">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-900" style={{ fontFamily: "var(--font-heading)" }}>
            推荐视频
          </h2>
          <p className="text-sm text-foreground-500 mt-1">编辑精选，为你推荐最优质的内容</p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop>
        {featuredVideos.map((video) => (
          <VideoCard key={video.id} video={video} />
        ))}
      </div>
    </section>
  );
}